var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-mobile-subscription"},[_c('mobile-subscription-wizard',{attrs:{"available-subscriptions":_vm.subscriptions},on:{"onCancel":_vm.cancelWizard,"onDone":_vm.createAccountSubscription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }